<template>
  <div v-loading="fundingRateLoading">
    
    <!-- <el-row>
      <el-col>
        <el-select v-model="params.symbol" clearable placeholder="请选择" @change="handelSymbol">
          <el-option
            v-for="item in symbolList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row> -->
  

    <el-row>
      <el-col :span="24">
        <div
          id="fundingRateBox"
          style="width: 100%; min-height: 700px"
        ></div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import IndexJs from "../fundingRate/index";
export default {
  mixins: [IndexJs],
};
</script>

<style>
</style>